/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const DIVISION_ID_PROP_PATH = 'DIVISION_ID_PROP_PATH';
export const GROUP_DETAIL_ALT_PROP_PATH = 'GROUP_DETAIL_ALT_PROP_PATH';
export const GROUP_DETAIL_PROP_PATH = 'GROUP_DETAIL_PROP_PATH';
export const GROUP_DETAIL_ALT_CONFIRM_PROP_PATH = 'GROUP_DETAIL_ALT_CONFIRM_PROP_PATH';
export const GROUP_INFO_PROP_PATH = 'GROUP_INFO_PROP_PATH';
export const GROUP_DETAIL_ADDRESS_PROP_PATH = 'GROUP_DETAIL_ADDRESS_PROP_PATH';
export const GROUP_DETAIL_FIRST_NAME_PROP_PATH = 'GROUP_DETAIL_FIRST_NAME_PROP_PATH';
export const GROUP_DETAIL_LAST_NAME_PROP_PATH = 'GROUP_DETAIL_LAST_NAME_PROP_PATH';
export const GROUP_DETAIL_MIDDLE_NAME_PROP_PATH = 'GROUP_DETAIL_MIDDLE_NAME_PROP_PATH';
export const GROUP_DETAIL_ZIPCODE_PROP_PATH = 'GROUP_DETAIL_ZIPCODE_PROP_PATH';
export const GROUP_DETAIL_ADDRESS1_PROP_PATH = 'GROUP_DETAIL_ADDRESS1_PROP_PATH';
export const GROUP_DETAIL_ADDRESS2_PROP_PATH = 'GROUP_DETAIL_ADDRESS2_PROP_PATH';
export const GROUP_DETAIL_STATE_PROP_PATH = 'GROUP_DETAIL_STATE_PROP_PATH';
export const GROUP_DETAIL_CITY_PROP_PATH = 'GROUP_DETAIL_CITY_PROP_PATH';
export const GROUP_DETAIL_EMAIL_PROP_PATH = 'GROUP_DETAIL_EMAIL_PROP_PATH';
export const GROUP_DETAIL_PHONE_PROP_PATH = 'GROUP_DETAIL_PHONE_PROP_PATH';
export const GROUP_DETAIL_COUNTRY_PROP_PATH = 'GROUP_DETAIL_COUNTRY_PROP_PATH';
export const GROUP_DETAIL_SAVE_PROFILE_PROP_PATH = 'GROUP_DETAIL_SAVE_PROFILE_PROP_PATH';

export const ANIMAL_DETAILS_PROP_PATH = 'ANIMAL_DETAILS_PROP_PATH';
export const IS_BRINGING_ANIMALS_PROP_PATH = 'IS_BRINGING_ANIMALS_PROP_PATH';

export const COMMENTS_PROP_PATH = 'COMMENTS_PROP_PATH';

export const CLIENT_INFO_PROP_PATH = 'CLIENT_INFO_PROP_PATH';

export const GROUP_LEADERS_GUIDES_PROP_PATH = 'GROUP_LEADERS_GUIDES_PROP_PATH';
export const IS_COMMERCIALLY_GUIDED_PROP_PATH = 'IS_COMMERCIALLY_GUIDED_PROP_PATH';

export const SERVICE_TYPE_PROP_PATH = 'SERVICE_TYPE_PROP_PATH';

export const EMERGENCY_CONTACT_FIRST_NAME_PROP_PATH =
    'EMERGENCY_CONTACT_FIRST_NAME_PROP_PATH';
export const EMERGENCY_CONTACT_LAST_NAME_PROP_PATH =
    'EMERGENCY_CONTACT_LAST_NAME_PROP_PATH';
export const EMERGENCY_CONTACT_PHONE_PROP_PATH = 'EMERGENCY_CONTACT_PHONE_PROP_PATH';

export const START_DATE_PROP_PATH = 'START_DATE_PROP_PATH';

export const EXIT_LOCATION_ID_PROP_PATH = 'EXIT_LOCATION_ID_PROP_PATH';
export const ENTRY_LOCATION_ID_PROP_PATH = 'ENTRY_LOCATION_ID_PROP_PATH';
export const PICKUP_LOCATION_PROP_PATH = 'PICKUP_LOCATION_PROP_PATH';
export const PARKING_LOT_PROP_PATH = 'PARKING_LOT_PROP_PATH';
export const TRAVEL_METHOD_TYPE_PROP_PATH = 'TRAVEL_METHOD_TYPE_PROP_PATH';
export const CAMPSITE_PREFERENCE_PROP_PATH = 'CAMPSITE_PREFERENCE_PROP_PATH';

export const STATUS_PROP_PATH = 'STATUS_PROP_PATH';
export const RESERVATION_NUMBER_PROP_PATH = 'RESERVATION_NUMBER_PROP_PATH';
export const QUOTA_TYPE_PROP_PATH = 'QUOTA_TYPE_PROP_PATH';

export const GROUP_SIZE_PROP_PATH = 'GROUP_SIZE_PROP_PATH';
export const SELECTED_GROUP_SIZE_PROP_PATH = 'SELECTED_GROUP_SIZE_PROP_PATH';
export const GROUP_MEMBERS_PROP_PATH = 'GROUP_MEMBERS_PROP_PATH';
export const GROUP_MEMBERS_FIRST_NAME_PROP_PATH = 'GROUP_MEMBERS_FIRST_NAME_PROP_PATH';
export const GROUP_MEMBERS_LAST_NAME_PROP_PATH = 'GROUP_MEMBERS_LAST_NAME_PROP_PATH';
export const GROUP_MEMBERS_EMAIL_PROP_PATH = 'GROUP_MEMBERS_EMAIL_PROP_PATH';
export const GROUP_MEMBERS_PHONE_PROP_PATH = 'GROUP_MEMBERS_PHONE_PROP_PATH';
export const GROUP_MEMBERS_ADDRESS1_PROP_PATH = 'GROUP_MEMBERS_ADDRESS1_PROP_PATH';
export const GROUP_MEMBERS_ADDRESS2_PROP_PATH = 'GROUP_MEMBERS_ADDRESS2_PROP_PATH';
export const GROUP_MEMBERS_CITY_PROP_PATH = 'GROUP_MEMBERS_CITY_PROP_PATH';
export const GROUP_MEMBERS_STATE_PROP_PATH = 'GROUP_MEMBERS_STATE_PROP_PATH';
export const GROUP_MEMBERS_ZIPCODE_PROP_PATH = 'GROUP_MEMBERS_ZIPCODE_PROP_PATH';
export const GROUP_MEMBERS_COUNTRY_PROP_PATH = 'GROUP_MEMBERS_COUNTRY_PROP_PATH';

export const NEED_TO_KNOW_CHECKED_PROP_PATH = 'NEED_TO_KNOW_CHECKED_PROP_PATH';

export const ADMIN_TYPE_PROP_PATH = 'ADMIN_TYPE_PROP_PATH';
export const ADMIN_JUSTIFICATION_PROP_PATH = 'ADMIN_JUSTIFICATION_PROP_PATH';
export const IS_ADMIN_PERMIT_PROP_PATH = 'IS_ADMIN_PERMIT_PROP_PATH';
export const BYPASS_QUOTA_CONSUMPTION_PROP_PATH = 'BYPASS_QUOTA_CONSUMPTION_PROP_PATH';
export const BYPASS_QUOTA_CHECK_PROP_PATH = 'BYPASS_QUOTA_CHECK_PROP_PATH';
export const BYPASS_RULES_VALIDATIONS_PROP_PATH = 'BYPASS_RULES_VALIDATIONS_PROP_PATH';
export const IS_LEGACY_ADMIN_PERMIT_PROP_PATH = 'IS_LEGACY_ADMIN_PERMIT_PROP_PATH';
export const IS_LEGACY_OVERRIDE_QUOTA_PROP_PATH = 'IS_LEGACY_OVERRIDE_QUOTA_PROP_PATH';

export const VEHICLE_IS_RENTAL_PROP_PATH = 'VEHICLE_IS_RENTAL_PROP_PATH';
export const VEHICLE_LICENSE_PLATE_PROP_PATH = 'VEHICLE_LICENSE_PLATE_PROP_PATH';
export const VEHICLE_MAKE_PROP_PATH = 'VEHICLE_MAKE_PROP_PATH';
export const VEHICLE_MODEL_PROP_PATH = 'VEHICLE_MODEL_PROP_PATH';
export const VEHICLE_PROP_PATH = 'VEHICLE_PROP_PATH';
export const VEHICLE_STATE_PROP_PATH = 'VEHICLE_STATE_PROP_PATH';
export const VEHICLE_TYPE_PROP_PATH = 'VEHICLE_TYPE_PROP_PATH';
export const VEHICLE_YEAR_PROP_PATH = 'VEHICLE_YEAR_PROP_PATH';

export const VEHICLES_PROP_PATH = 'VEHICLES_PROP_PATH';
export const VEHICLES_LICENSE_PLATE_PROP_PATH = 'VEHICLES_LICENSE_PLATE_PROP_PATH';
export const VEHICLES_STATE_PROP_PATH = 'VEHICLES_STATE_PROP_PATH';
export const VEHICLES_MAKE_PROP_PATH = 'VEHICLES_MAKE_PROP_PATH';
export const VEHICLES_TYPE_PROP_PATH = 'VEHICLES_TYPE_PROP_PATH';

export const EQUIPMENTS_PROP_PATH = 'EQUIPMENTS_PROP_PATH';
export const EQUIPMENTS_TYPE_PROP_PATH = 'EQUIPMENTS_TYPE_PROP_PATH';
export const EQUIPMENTS_QUANTITY_PROP_PATH = 'EQUIPMENTS_QUANTITY_PROP_PATH';

export const ATTRIBUTE_DATE_DATA_TYPE_PROP_PATH = 'ATTRIBUTE_DATE_DATA_TYPE_PROP_PATH';

export const LOTTERY_CHOICES_PROP_PATH = 'LOTTERY_CHOICES_PROP_PATH';

export const FLEX_FIELD_1 = 'FLEX_FIELD_1';
export const FLEX_FIELD_2 = 'FLEX_FIELD_2';
